import styled from 'styled-components';

export const Section = styled.section`
  background: radial-gradient(
    50% 50% at 50% 50%,
    #292943 0%,
    rgba(41, 41, 67, 0) 100%
  );
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 40px;
  @media (min-width: 768px) {
    padding-top: 160px;
    position: relative;
  }
  @media (min-width: 1440px) {
    position: static;
    padding-top: 80px;
  }
`;

export const LeftPhone = styled.img`
  display: block;
  position: absolute;
  left: -44px;
  width: 80px;
  height: 200px;

  @media (min-width: 376px) {
    left: -70px;
    width: 100px;
    height: 250px;
  }
  @media (min-width: 767px) {
    left: -20px;
  }
  @media (min-width: 768px) {
    left: -110px;
    width: 180px;
    height: 450px;
  }
  @media (min-width: 1280px) {
    width: 220px;
    height: 550px;
    position: static;
  }
`;
export const RightPhone = styled.img`
  display: block;
  position: absolute;
  right: -44px;
  width: 80px;
  height: 200px;

  @media (min-width: 376px) {
    right: -70px;
    width: 100px;
    height: 250px;
  }

  @media (min-width: 767px) {
    right: -20px;
  }
  @media (min-width: 768px) {
    right: -110px;
    width: 180px;
    height: 450px;
  }
  @media (min-width: 1280px) {
    width: 220px;
    height: 550px;
    position: static;
  }
`;

export const MiddleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  min-height: 248px;

  @media (min-width: 376px) {
    min-width: 260px;
  }
  @media (min-width: 768px) {
    min-width: 300px;
    padding: 0 40px;
  }

  @media (min-width: 1440px) {
    min-width: 496px;
  }
`;

export const FlexColCentr = styled.div`
  display: 'flex';
  flex-direction: 'column';
  align-items: 'center';
  margin-bottom: 80px;
  @media (min-width: 768px) {
    margin-bottom: 40px;
    width: 90%;
  }
`;

export const FlexColCentrPad = styled.div`
  display: 'flex';
  flex-direction: 'column';
  align-items: 'center';
  padding: 0 10px;
  @media (min-width: 768px) {
    padding: 0 40px;
  }
`;

export const PreTitle = styled.p`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: center;
  color: #aaabbc;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 19px;
  }
`;

export const TitleMain = styled.p`
  /* H1 */
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 800;

  font-size: 22px;

  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
  @media (min-width: 768px) {
    font-size: 30px;
    line-height: 44px;
  }
`;

export const DescriptionMain = styled.p`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.1px;
  color: #aaabbc;
  opacity: 0.7;
  @media (min-width: 768px) {
    font-size: 18px;
    line-height: 27px;
  }
`;

export const Link = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: #aaabbc;

  border-bottom: 0.5px solid;

  :hover {
    color: red;
  }
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 767px) {
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const ButtonLink = styled.a`
  :last-child {
    /* margin-bottom: 80px; */
  }

  @media (min-width: 768px) {
    :first-child {
      margin-right: 20px;
    }
  }

  @media (min-width: 1440px) {
    margin-left: 0;
    margin-bottom: 0;
  }
`;

export const AppleFooterButton = styled.img`
  width: 160px;
  border-radius: 7px;
  /* margin-bottom: 40px; */
  &:hover {
    opacity: 0.5;
  }

  @media (min-width: 768px) {
    width: 190px;
    height: 48px;
  }

  @media (min-width: 1440px) {
    /* margin-bottom: 10px; */
  }
`;

export const GoogleFooterButton = styled.img`
  width: 160px;
  border-radius: 6px;
  margin-bottom: 20px;
  &:hover {
    opacity: 0.7;
  }

  @media (min-width: 768px) {
    width: 190px;
    height: 48px;
    margin-bottom: 0;
  }

  @media (min-width: 1440px) {
    /* margin-bottom: 10px; */
  }
`;
